import { Flex } from "@chakra-ui/react";
import { useLoading } from "components/GlobalLoading";
import useClienteEndereco from "core/features/cliente/hooks/useClienteEndereco";
import useSaveClienteEndereco from "core/features/cliente/hooks/useSaveClienteEndereco";
import { EnderecoDto } from "core/features/unidades/typings/unidade";
import history from "infra/helpers/history";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import FormEndereco from "ui/components/FormEndereco";
import { Box } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/layout";
import OutlineButton from "ui/components/Button/OutlineButton";

export default function EnderecoCliente({ clienteId }: { clienteId: string }) {
  const { data, isLoading, isFetching, refetch } =
    useClienteEndereco(clienteId);

  const { mutate: saveEndereco, isLoading: isLoadingSave } =
    useSaveClienteEndereco(clienteId);

  const { control, handleSubmit, reset, watch, setValue } = useForm<{
    endereco: EnderecoDto;
  }>({
    defaultValues: {},
  });

  const _handleSave = (form: { endereco: EnderecoDto }) => {
    saveEndereco(form.endereco, {
      onSuccess: () => {
        refetch();
      },
    });
  };

  useEffect(() => {
    if (data) {
      reset({
        endereco: data,
      });
    }
  }, [data, reset]);

  useLoading(isLoading || isFetching);

  return (
    <>
      <Box mb={8}>
        <Text fontSize="18px" fontWeight="bold">
          Endereço
        </Text>
      </Box>

      <FormEndereco control={control} watch={watch} setField={setValue} />

      <Flex justifyContent={"flex-end"} mt="32px" gap={4}>
        <OutlineButton onClick={() => history.push("/cadastros/clientes")}>
          Voltar
        </OutlineButton>

        <PrimaryButton
          isDisabled={isLoadingSave}
          isLoading={isLoadingSave}
          onClick={handleSubmit(_handleSave)}
        >
          Salvar
        </PrimaryButton>
      </Flex>
    </>
  );
}
